(function ($) {
  'use strict';

  // Adds pager counter for the slick gallery.
  $('.slick').each(function () {
    var that = this;
    var t = $('> .slick__slider', that).length ? $('> .slick__slider', that) : $(that);

    t.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      // CurrentSlide is undefined on init, so set it to 0 in this case
      // (currentSlide is 0 based).
      var i = (currentSlide ? currentSlide : 0) + 1;
      if (!($('.slick-counter', that).length)) {
        $('<div class="slick-counter"></div>').insertAfter('.slick-prev', that);
      }

      $('.slick-counter', that).text(i + '/' + slick.slideCount);
    });
  });

  // @todo: Remove this once custom-styleguide-specific.js is added properly.
  //        @see /themes/custom/dostheme/source/_meta/_00-head.twig
  if (typeof Drupal === 'undefined') {
    $(document).ready(function () {
      if ($('.slick__slider').length) {
        $('.slick__slider').slick({
          slide: '.media-image',
          mobileFirst: true,
          centerMode: true,
          centerPadding: '0px',
          swipeToSlide: true,
          appendArrows: '.slick__arrow'
        });
      }
    });
  }
})(jQuery);
